import React from 'react';
import { connect } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import YoutubeMultiPlay from '../YoutubeComponents/YoutubeMultiPlay';
import _ from 'lodash';
import {
	CheckboxesContainer,
	FormControlSongsList,
	ListYoutubeContainer,
	SongButtonsContainer,
	// SongContainer,
	SongButton,
	SongsListContainer,
	SongsListLi,
	SongsListUl,
	YoutubeContainer
} from './StyledComponents/StyleSongsList';
import {
	addSongToFavoritesList,
	addSongToFavoritesListRequest,
	getCountryArtistsRequest,
	getCountrySongsRequest,
	removeSongFromFavoritesList,
	removeSongFromFavoritesListRequest,
	selectSongToViewInfo,
	deleteSelectedSong,
	deleteSelectedSongRequest,
	getUserUploadedSongsRequest,
	selectSongToEdit
} from '../../state-management/actions/songs-actions';
import {
	closeCountrySongsModal,
	closeAddSongToPlaylistModal,
	openAddSongToPlaylistModal,
	openEditSongModal
} from '../../state-management/actions/modal-actions';
import {
	PrimaryButton,
	SecondaryButton,
	TertiaryButton,
	QuaternaryButton,
	flexDirection
} from '../../style/Global';
import MediaQuery from 'react-responsive'


// BUFFERING: 3
// ​
// CUED: 5
// ​
// ENDED: 0
// ​
// PAUSED: 2
// ​
// PLAYING: 1
// ​
// UNSTARTED: -1


const youtubePlayerStateMap = {
	'3':'BUFFERING',
	'5':'CUED',
	'0':'ENDED',
	'2':'PAUSED',
	'1':'PLAYING',
	'-1':'UNSTARTED'
}

class SongsList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			genres: [],
			songsList: [],
			filteredSongsByGenre: [],
			genreSelected: null,
			genreDropdownOpen: false,
			checkBoxesStatus: {},
			sortBy: 'shuffle',
			playerState: {
				songSelected: {},
				playAutomatically: false,
				firstSongPlay: false
			},
			youtubePlayerState:'',
			loadedSongsList: false,
			requestIdentifierLocal: '',
			selectAllStatus: true,
			menuInView: 'songs'
		};
	}

	componentDidMount() {
		this.loadSongs();
	}

	componentDidUpdate(prevProps) {
		const {
			requestIdentifierLocal
		} = this.state;
		const {
			requestIdentifierForeign,
			songsList
		} = this.props;
		// console.log('requestIdentifierLocal', requestIdentifierLocal);
		// console.log('requestIdentifier', requestIdentifierForeign);
		if (requestIdentifierLocal !== requestIdentifierForeign || (prevProps.songsList.length !== songsList.length)) {
			// console.log('load');
			this.loadSongs();

			this.setState((prevState) => ({
				...prevState,
				loadedSongsList: true,
				requestIdentifierLocal: requestIdentifierForeign
			}));
		}
	}

	componentWillUnmount() {
		console.log('unmount');
	}
	addToFavorites = (song) => {
		const { addSongToFavoritesList, addSongToFavoritesListRequest } = this.props;
		addSongToFavoritesList(song);
		addSongToFavoritesListRequest(song);
	}

	addToPlaylist = (song) => {
	}

	closeCountrySongsModal = () => {
		const { closeCountrySongsModal, history } = this.props;
		closeCountrySongsModal();
		history.push('/explore');
	}

	loadSongs = () => {
		const {
			sortBy
		} = this.state;
		const { songsList } = this.props;
		// console.log('songsList', songsList);

		const genres = _(songsList)
			.sortBy(videos => {
				return videos.genre;
			})
			.map(videos => {
				return videos.genre;
			})
			.uniqBy()
			.value();

		// console.log('genres', genres);
		const checkBoxesStatus = genres.reduce((o, genre) => ({ ...o, [genre]: true }), {});

		// const 
		const songSelected = songsList.length > 0 ? {
			index: 0,
			// musicVideo: songsList[0].musicVideo
			...songsList[0]
		}
			: '';

		this.setState((prevState) => ({
			...prevState,
			checkBoxesStatus,
			genres,
			songsList,
			filteredSongsByGenre: _(songsList).shuffle().value(),
			playerState: {
				...prevState.playerState,
				songSelected
			}
		}));

		// setTimeout(()=>{
		// 	this.setSortBy(sortBy);

		// }, 100);
		// this.setSortBy(sortBy);
	}

	removeFromFavorites = (song) => {
		const { removeSongFromFavoritesList, removeSongFromFavoritesListRequest } = this.props;
		removeSongFromFavoritesList(song);
		removeSongFromFavoritesListRequest(song);
	}

	onGenreSelected = (event) => {
		const { value } = event.target;
		const {
			checkBoxesStatus,
			playerState,
			songsList,
			sortBy
		} = this.state;
		const {
			index: songIndex,
			songSelected: previousSongSelected
		} = playerState;
		console.log('player state', playerState);
		// console.log('genre sel', value);

		const currentCheckBoxStatus = checkBoxesStatus[value];

		let tempCheckBoxesStatus = _.assign({}, checkBoxesStatus);
		tempCheckBoxesStatus[value] = !currentCheckBoxStatus;
		const filteredSongsByGenre = _(songsList)
			.filter(song => {
				return tempCheckBoxesStatus[song.genre] ? song : false;
			})
			.sortBy(song => song[sortBy])
			.value();

		console.log('genre state', tempCheckBoxesStatus[value]);

		if (previousSongSelected.genre === value && tempCheckBoxesStatus[value] === false) {
			// console.log('change index');

			const nextSong = filteredSongsByGenre[previousSongSelected.index] ? filteredSongsByGenre[previousSongSelected.index] : filteredSongsByGenre[0];


			// console.log('next exists', nextSong);

			// const playerState = {
			// 	...playerState,
			// 	songSelected:{...songsList[previousSongSelected.index + 1], index:previousSongSelected.index + 1}
			// }

			this.setState((prevState) => ({
				...prevState,
				checkBoxesStatus: {
					...prevState.checkBoxesStatus,
					[value]: !currentCheckBoxStatus
				},
				filteredSongsByGenre,
				playerState: {
					...prevState.playerState,
					songSelected: { ...filteredSongsByGenre[previousSongSelected.index], index: previousSongSelected.index }
				}

			}));
		}
		else {
			this.setState((prevState) => ({
				...prevState,
				checkBoxesStatus: {
					...prevState.checkBoxesStatus,
					[value]: !currentCheckBoxStatus
				},
				filteredSongsByGenre

			}));
		}

	}

	onSelectAll = () => {
		const {
			genres,
			selectAllStatus: oldSelectAllStatus,
			songsList,
			sortBy
		} = this.state;

		const selectAllStatus = !oldSelectAllStatus;
		const checkBoxesStatus = selectAllStatus ? genres.reduce((o, genre) => ({ ...o, [genre]: true }), {})
			: genres.reduce((o, genre) => ({ ...o, [genre]: false }), {});

		const filteredSongsByGenre = _(songsList)
			.filter(song => {
				return checkBoxesStatus[song.genre] ? song : false;
			})
			.sortBy(song => song[sortBy])
			.value();

		console.log('checkBoxesStatus', checkBoxesStatus);
		console.log('selectAllStatus', selectAllStatus);
		console.log('filters', filteredSongsByGenre);
		this.setState((prevState) => ({
			...prevState,
			selectAllStatus,
			filteredSongsByGenre,
			checkBoxesStatus
		}));

	}

	onDeleteSongClick = (songToDelete) => {
		const { deleteSelectedSong, deleteSelectedSongRequest } = this.props;
		deleteSelectedSong(songToDelete);
		deleteSelectedSongRequest(songToDelete);
	}

	onEditSongClick = (song) => {
		const { 
			getCountryArtistsRequest,
			openEditSongModal, 
			selectSongToEdit 
		} = this.props;
		const {
			countrySelected
		} = song;
		const selectedCountry = {
			countrySelected
		}
		getCountryArtistsRequest(selectedCountry);
		selectSongToEdit(song._id);
		openEditSongModal();
	}

	onSortBy = (event) => {		
		const { value } = event.target;


		this.setSortBy(value);


		console.log('sorting', value);

		

	}

	onPause = () => {
		this.setState((prevState) => ({
			...prevState,
			playerState: {
				...prevState.playerState,
				playAutomatically: false
			}

		}));
	}

	onSongEnd = () => {
		const { filteredSongsByGenre, playerState, } = this.state;
		const numberSongs = filteredSongsByGenre.length;

		const { songSelected: previousSongSelected } = playerState;
		const songSelectedIndex = previousSongSelected.index;
		const newSongSelectedIndex = songSelectedIndex + 1 > numberSongs - 1 ? 0 : songSelectedIndex + 1;

		const nextSong = filteredSongsByGenre[newSongSelectedIndex] ? filteredSongsByGenre[newSongSelectedIndex] : filteredSongsByGenre[0];
		console.log('filteredSongsByGenre', filteredSongsByGenre);
		const songSelected = {
			index: newSongSelectedIndex,
			...nextSong
		}

		this.setState((prevState) => ({
			...prevState,
			playerState: {
				...prevState.playerState,
				songSelected,
				playAutomatically: true
			}

		}));
	}


	removeSongFromPlaylist = (song) => {
		const {
			openPlaylist,
			removeSongFromPlaylist,
			removeSongFromPlaylistRequest
		} = this.props;

		const { _id } = openPlaylist;

		const songPlaylist = {
			_id,
			song
		}
		removeSongFromPlaylist(songPlaylist);
		removeSongFromPlaylistRequest(songPlaylist);
	}

	selectSongToBeAddedToPlaylist = (song) => {
		const {
			openAddSongToPlaylistModal,
			selectSongToBeAddedToPlaylist
		} = this.props;
		openAddSongToPlaylistModal();
		selectSongToBeAddedToPlaylist(song);
	}

	setPlayerState = (youtubePlayerStateNumber) => {
		const youtubePlayerState = youtubePlayerStateMap[youtubePlayerStateNumber]

		// console.log('aaa',youtubePlayerStateNumber);
		this.setState((prevState) => ({
			...prevState,
			youtubePlayerState
		}));

		// console.log('youtubePlayerState', youtubePlayerState);
	}

	setSongListWordingChange = () => {
		this.setState((prevState) => ({
			...prevState,
			playerState: {
				...prevState.playerState,
				firstSongPlay: true
			}
		}));
	}

	setSortBy = (value) => {
		const { filteredSongsByGenre } = this.state;
		if (value === 'shuffle') {
			const shuffledFilteredSongsByGenre = _(filteredSongsByGenre).shuffle().value();

			console.log('shuffled', shuffledFilteredSongsByGenre);

			this.setState((prevState) => ({
				...prevState,
				filteredSongsByGenre: shuffledFilteredSongsByGenre,
				sortBy: value
			}));
		}

		else {

			const tempFilteredSongsByGenre = _(filteredSongsByGenre)
				.sortBy(song => song[value])
				.value();
			this.setState((prevState) => ({
				...prevState,
				filteredSongsByGenre: tempFilteredSongsByGenre,
				sortBy: value
			}));
		}

	}

	skipBackward = () => {
		const { filteredSongsByGenre, playerState, } = this.state;
		const numberSongs = filteredSongsByGenre.length;

		const { songSelected: previousSongSelected } = playerState;
		const songSelectedIndex = previousSongSelected.index;
		const newSongSelectedIndex = songSelectedIndex - 1 === -1 ? numberSongs - 1 : songSelectedIndex - 1;

		const nextSong = filteredSongsByGenre[newSongSelectedIndex] ? filteredSongsByGenre[newSongSelectedIndex] : filteredSongsByGenre[0];
		console.log('filteredSongsByGenre', filteredSongsByGenre);
		const songSelected = {
			index: newSongSelectedIndex,
			...nextSong
		}

		this.setState((prevState) => ({
			...prevState,
			playerState: {
				...prevState.playerState,
				songSelected,
				playAutomatically: true,
			}

		}));
		this.setSongListWordingChange();
	}

	skipForward = () => {
		const { filteredSongsByGenre, playerState, } = this.state;
		const numberSongs = filteredSongsByGenre.length;

		const { songSelected: previousSongSelected } = playerState;
		const songSelectedIndex = previousSongSelected.index;
		const newSongSelectedIndex = songSelectedIndex + 1 > numberSongs - 1 ? 0 : songSelectedIndex + 1;

		const nextSong = filteredSongsByGenre[newSongSelectedIndex] ? filteredSongsByGenre[newSongSelectedIndex] : filteredSongsByGenre[0];
		console.log('filteredSongsByGenre', filteredSongsByGenre);
		const songSelected = {
			index: newSongSelectedIndex,
			...nextSong
		}

		this.setState((prevState) => ({
			...prevState,
			playerState: {
				...prevState.playerState,
				songSelected,
				playAutomatically: true,
			}

		}));
		this.setSongListWordingChange();
	}

	selectSong = (songSelected, index) => {
		const {youtubePlayerState} = this.state;
		// console.log('sselect song');
		if (!youtubePlayerState){
			return;
		}

		const songSelectedObj = {
			index,
			...songSelected
		}
		this.setState((prevState) => ({
			...prevState,
			playerState: {
				...prevState.playerState,
				songSelected: songSelectedObj,
				playAutomatically: true,
			}
		}));
		this.setSongListWordingChange();
	}

	setMobileView = (menuInView) => {
		this.setState((prevState) => ({
			...prevState,
			menuInView
		}));
	}

	render() {
		const {
			actionsAllowed,
			authenticated,
			favoriteSongs
		} = this.props;
		const { checkBoxesStatus,
			genres,
			filteredSongsByGenre,
			playerState,
			selectAllStatus,
			songsList,
			sortBy,
			menuInView,
			youtubePlayerState
		} = this.state;
		const { firstSongPlay, playAutomatically, songSelected } = playerState;
		const favoriteSongsLookup = _.groupBy(favoriteSongs, favoriteSong => favoriteSong._id);

		// const isTabletOrMobile = useMediaQuery({ query: device.tablet });

		// console.log('is table or mobile', isTabletOrMobile);
		// console.log('songs list state', this.state);
		// console.log('youtubePlayerState', youtubePlayerState);
		// console.log('first son', firstSongPlay);
		return (
			<>
			
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end'
					}}
				>
					{
						actionsAllowed.includes('refresh') &&
						<div>
						<PrimaryButton
							className='country-songs-button song-button'
							variant="outlined"
							onClick={this.refreshList}
							style={{
								marginRight: '5px'
							}}
						>
							Refresh
						</PrimaryButton>
					</div>
					}
					<div>
						<QuaternaryButton
							className='country-songs-button song-button'
							variant="outlined"
							onClick={() => this.setMobileView('genres')}
							style={{
								marginRight: '5px'
							}}
						>
							Filters
						</QuaternaryButton>
					</div>
					<div>
						<QuaternaryButton
							className='country-songs-button song-button'
							variant="outlined"
							onClick={() => this.setMobileView('songs')}
						>
							Songs
						</QuaternaryButton>
					</div>
				</div>
				{
					// menuInView === 'songs' &&
					<ListYoutubeContainer className='ref-list-youtube-container'>
						<YoutubeContainer
							className='ref-youtube-container'
						>
							{
								songSelected !== '' &&
								<YoutubeMultiPlay
									musicVideo={songSelected.musicVideo}
									onPause={this.onPause}
									onSongEnd={this.onSongEnd}
									songSelected={songSelected}
									setPlayerState={this.setPlayerState}
									setSongListWordingChange={this.setSongListWordingChange}
									skipForward={this.skipForward}
									skipBackward={this.skipBackward}
									playAutomatically={playAutomatically}
									firstSongPlay={firstSongPlay}
								/>
							}
						</YoutubeContainer>
						{
							menuInView === 'genres' &&
							<div
								style={flexDirection.column}
							>
																
								<div className='filter-container'>
									{songsList.length >= 2 &&
										<FormControlSongsList
											style={{
												width: '150px'
											}}
										>
											<InputLabel>Sort Song List By</InputLabel>
											<Select
												value={sortBy}
												onChange={this.onSortBy}
												// onChange={()=>console.log('sort')}
												inputProps={{
													name: 'sort-by',
													id: 'sort-by-simple',
												}}
											>
												<MenuItem value='artist'>Artist</MenuItem>
												<MenuItem value='name'>Song</MenuItem>
												<MenuItem value='shuffle'>Shuffle</MenuItem>
											</Select>
										</FormControlSongsList>
									}
								</div>
								<div
									onClick={this.onSelectAll}
									style={{
										cursor: 'pointer'
									}}
								>
									<h5>{selectAllStatus ? 'Unselect all genres' : 'Select all genres'}</h5>
								</div>
								<CheckboxesContainer className='ref-checkboxes-container'>
									{
										genres && genres.map((genre) => (
											<FormControlLabel
												control={
													<Checkbox
														checked={checkBoxesStatus[genre]}

														onChange={this.onGenreSelected}
														value={genre}
														color="primary"
													/>
												}
												key={genre}
												label={genre}
											/>
										))
									}
								</CheckboxesContainer>
							</div>
						}
						{
							menuInView === 'songs' &&
							<SongsListContainer className='ref-country-songs-list-container'>
								{
									songsList.length > 0 ?
										<SongsListUl className='ref-country-songs-list-ul'>
											{
												filteredSongsByGenre.map((song, index) => (
													<SongsListLi
														className='ref-country-songs-list-li'
														key={song._id}
													>
														<div>
															<h6>
																{index + 1 + ' '}{song.name}
															</h6>
															<p>
																{song.artist}
															</p>
														</div>
														<SongButtonsContainer className='ref-country-songs-buttons-container'>
															<MediaQuery
																maxDeviceWidth={768}
															>
																<SongButton
																	className='country-songs-button quaternary-button song-button'
																	variant="outlined"
																	style={{
																		padding: '0px'
																	}}
																	onClick={() => this.selectSong(song, index)}
																>
																	{/* {songSelected.musicVideo === song.musicVideo && firstSongPlay ? 'Playing' : 'Play'} */}
																	{songSelected.musicVideo === song.musicVideo &&  firstSongPlay &&
																	(youtubePlayerState ==='PLAYING' ||youtubePlayerState ==='BUFFERING' ||
																	youtubePlayerState ==='CUED') && 'Playing'}
																	{songSelected.musicVideo === song.musicVideo && youtubePlayerState ==='PAUSED' && 'Paused'}																
																	{songSelected.musicVideo === song.musicVideo && youtubePlayerState ==='' && 'Play'}
																	{songSelected.musicVideo === song.musicVideo && youtubePlayerState ==='CUED' && !firstSongPlay && 'Play'}
																	{songSelected.musicVideo !== song.musicVideo && 'Play'}
																</SongButton>
															</MediaQuery>
															<MediaQuery
																minDeviceWidth={769}
															>
																{/* <div
																	style={{
																		display:'flex',
																		justifyContent:'flex-end'
																	}}
																> */}
																<SongButton
																	className='country-songs-button quaternary-button song-button'
																	variant="outlined"
																	// style={{
																	// 	padding: '0px'
																	// }}
																	onClick={() => this.selectSong(song, index)}
																>
																	{/* {songSelected.musicVideo === song.musicVideo && firstSongPlay ? 'Playing' : 'Play'} */}
																	{songSelected.musicVideo === song.musicVideo && firstSongPlay &&
																	(youtubePlayerState ==='PLAYING' ||youtubePlayerState ==='BUFFERING' ||
																	youtubePlayerState ==='CUED') && 'Playing'}
																	{songSelected.musicVideo === song.musicVideo && youtubePlayerState ==='PAUSED' && 'Paused'}															
																	{songSelected.musicVideo === song.musicVideo && youtubePlayerState ==='' && 'Play'}
																	{songSelected.musicVideo === song.musicVideo && youtubePlayerState ==='CUED' && !firstSongPlay && 'Play'}
																	{songSelected.musicVideo !== song.musicVideo && 'Play'}
																</SongButton>
																{/* </div> */}
															</MediaQuery>
															
														</SongButtonsContainer>


													</SongsListLi>
												))
											}

										</SongsListUl> : ''
									// <EmptyCountryDialog />
								}

							</SongsListContainer>
						}

					</ListYoutubeContainer>
				}
			</>
		);
	}
}

const mapStateToProps = state => {
	const {
		authenticationReducers,
		playlistReducers,
		songsReducers } = state;
	const {
		favoriteSongs,
		loadedCountrySongs,
		selectedCountryName,
		selectedCountrySongs
	} = songsReducers;

	const {
		openPlaylist
	} = playlistReducers;
	return {
		favoriteSongs,
		loadedCountrySongs,
		openPlaylist,
		selectedCountryName,
		selectedCountrySongs
	}
};

const mapDispatchToProps = (dispatch) => {

	return {
		addSongToFavoritesList: (song) => dispatch(addSongToFavoritesList(song)),
		addSongToFavoritesListRequest: (favoriteSongsList) => dispatch(addSongToFavoritesListRequest(favoriteSongsList)),
		
		closeCountrySongsModal: () => dispatch(closeCountrySongsModal()),
		closeAddSongToPlaylistModal: () => dispatch(closeAddSongToPlaylistModal()),
		getCountryArtistsRequest:(country) => dispatch(getCountryArtistsRequest(country)),
		getCountrySongsRequest: countrySongs => dispatch(getCountrySongsRequest(countrySongs)),
		openAddSongToPlaylistModal: () => dispatch(openAddSongToPlaylistModal()),
		removeSongFromFavoritesList: (song) => dispatch(removeSongFromFavoritesList(song)),
		removeSongFromFavoritesListRequest: (song) => dispatch(removeSongFromFavoritesListRequest(song)),
	
	
		selectSongToViewInfo: (song) => dispatch(selectSongToViewInfo(song)),
		deleteSelectedSong: (songToDelete) => dispatch(deleteSelectedSong(songToDelete)),
		deleteSelectedSongRequest: (songToDelete) => dispatch(deleteSelectedSongRequest(songToDelete)),
		getUserUploadedSongsRequest: () => dispatch(getUserUploadedSongsRequest()),
		selectSongToEdit: (songToEdit) => dispatch(selectSongToEdit(songToEdit)),
		openEditSongModal: () => dispatch(openEditSongModal())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SongsList);